// @flow

import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindModal, Modal, useModal } from "../../comum";
import { abrirTemplate, isModoSeries } from "../../../state";
import ListaTemplatesMedidas from "../lista-templates-medidas";
import { Translate } from "@quantum/i18n";

import "./templates-modal.css";

function TemplatesModal() {
  const modalDeTemplates = useModal("templates");
  const fecharModal = modalDeTemplates.close;
  const modoSeries = useSelector(isModoSeries);

  const dispatch = useDispatch();

  const handleSelecao = useCallback(
    arquivo => {
      dispatch(abrirTemplate(arquivo));
      fecharModal();
    },
    [dispatch, fecharModal]
  );

  return (
    <Modal
      {...bindModal(modalDeTemplates)}
      mountOnShow
      className="TemplatesModal"
    >
      <Modal.Header className="TemplatesModal__header" closeButton>
        <Modal.Title className="TemplatesModal__header-title">
          Templates |{" "}
          {modoSeries ? (
            <Translate>maiusculas.series</Translate>
          ) : (
            <Translate>maiusculas.relatorio</Translate>
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ListaTemplatesMedidas
          handleSelecionarArquivo={handleSelecao}
          abrirTemplate={abrirTemplate}
        />
      </Modal.Body>
    </Modal>
  );
}

export default TemplatesModal;
